/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AchievementConditionType } from './AchievementConditionType';
import {
    AchievementConditionTypeFromJSON,
    AchievementConditionTypeFromJSONTyped,
    AchievementConditionTypeToJSON,
    AchievementConditionTypeToJSONTyped,
} from './AchievementConditionType';

/**
 * 
 * @export
 * @interface AchievementConditionResponse
 */
export interface AchievementConditionResponse {
    /**
     * 
     * @type {AchievementConditionType}
     * @memberof AchievementConditionResponse
     */
    type: AchievementConditionType;
    /**
     * Target value (e.g. 10 wins, 1000 points, 7 days)
     * @type {number}
     * @memberof AchievementConditionResponse
     */
    threshold: number;
    /**
     * LEADERBOARD_FINISHES only. When set, a finish counts toward the threshold only if the rank was this good or better — so {threshold 3, rankCutoff 10} means "finish top 10, three times". Omit to count a finish at any position.
     * 
     * @type {number}
     * @memberof AchievementConditionResponse
     */
    rankCutoff?: number;
}



/**
 * Check if a given object implements the AchievementConditionResponse interface.
 */
export function instanceOfAchievementConditionResponse(value: object): value is AchievementConditionResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    return true;
}

export function AchievementConditionResponseFromJSON(json: any): AchievementConditionResponse {
    return AchievementConditionResponseFromJSONTyped(json, false);
}

export function AchievementConditionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AchievementConditionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': AchievementConditionTypeFromJSON(json['type']),
        'threshold': json['threshold'],
        'rankCutoff': json['rankCutoff'] == null ? undefined : json['rankCutoff'],
    };
}

export function AchievementConditionResponseToJSON(json: any): AchievementConditionResponse {
    return AchievementConditionResponseToJSONTyped(json, false);
}

export function AchievementConditionResponseToJSONTyped(value?: AchievementConditionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': AchievementConditionTypeToJSON(value['type']),
        'threshold': value['threshold'],
        'rankCutoff': value['rankCutoff'],
    };
}

